import { gql } from '@apollo/client'

export const CARD_FRAGMENT = gql`
  fragment Card on Card {
    brand
    last4
    expMonth
    expYear
  }
`
